/** @format */

import { createSelector } from 'reselect';

const selectMessageHistory = (state) => state.messageHistory;

/**
 * messagehistory: {
 *  flightId:{
 *      pilotsMessages:[],
 *      voucherMessages:[]
 *  },
 * flightId:{
 *     pilotsMessages:[],
 *    voucherMessages:[]
 * },
 * ...
 * }
 */
export const selectMessageHistories = createSelector(
  [selectMessageHistory],
  (messageHistory) => messageHistory.messageHistory
);

export const selectIsMessageHistoryFetching = createSelector(
  [selectMessageHistory],
  (messageHistory) => messageHistory.isFetching
);

export const selectMessageHistoryErrorMessage = createSelector(
  [selectMessageHistory],
  (messageHistory) => messageHistory.errorMessage
);
